import script from "./scrollToTop.vue?vue&type=script&setup=true&lang=js"
export * from "./scrollToTop.vue?vue&type=script&setup=true&lang=js"

import "./scrollToTop.vue?vue&type=style&index=0&id=42dce033&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42dce033"]])

export default __exports__